module.exports = __webpack_public_path__ + "img/android.887893eb.webp";